import { takeLatest, put, call } from 'redux-saga/effects';
import {
  fetchPostAcqUWMsrHomes,
  appNotify,
  setPostAcqUWMsrHomes,
  setIsFetchingPostAcqUWMsrHomes
} from 'store/actions';
import { getWithToken, getWithTokenV2 } from 'api/network';

export function* getPostAcqUWMsrHomesSaga() {
  yield takeLatest(fetchPostAcqUWMsrHomes, function* ({ payload: taskId }) {
    try {
      yield call(getMsrHomes, taskId);
      yield put(setIsFetchingPostAcqUWMsrHomes(false));
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
      yield put(setIsFetchingPostAcqUWMsrHomes(false));
    }
  });
}

export function* getMsrHomes(taskId) {
  let msrHomesDto = null;
  try {
     const msrHomesResponse = yield getWithTokenV2(`/api/postAcquisition/tasks/${taskId}/msrHomes`)
     yield put(setPostAcqUWMsrHomes(msrHomesResponse));
  } catch (error) {
    yield put(appNotify(error.message, 'error'));
  }
  return msrHomesDto;
}